export default __webpack_public_path__ + "static/media/volkihar-enderal-large.73ca37dd.jpg";